export enum FileType {
    'themePedagoDocPdf',
    'lessonPdf',
    'themePdf'
}